import type { Vehicle } from '../../components/CarInsurance/context';

/**
 * Make, model, variant and year must all be set before a quote is requested
 * (INS-6530): the gateway returns no result for a partial vehicle.
 */
export const isVehicleSelectionComplete = (vehicle: Vehicle): boolean =>
  Boolean(
    vehicle.makeName &&
      vehicle.modelCode &&
      vehicle.trim &&
      vehicle.manufactureYear,
  );
